module.exports = __webpack_public_path__ + "media/img/partners/gostudy-logo-1031a8c69b0285482084cc2a418e0f0f.png";